import * as React from 'react'
import { PreDefinedFilters } from '../treeManipulation/preDefinedFilters/PreDefinedFilters'
import { PreDefinedFilterTypes } from '../treeManipulation/preDefinedFilters/utility'

export function FindNodeTypes({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  return (
    <PreDefinedFilters
      treeId={treeId}
      versionId={versionId}
      filters={[
        PreDefinedFilterTypes.AllNodes,
        PreDefinedFilterTypes.AllQuestions,
      ]}
    />
  )
}
